<template>
  <div
    class="notifyContainer"
    v-show="
      String($store.state.userInfo.authority).includes('财务审核') ||
        String($store.state.userInfo.authority).includes('领导审核') ||
        String($store.state.userInfo.authority).includes('总经理审核')
    "
  >
    <div class="notifyCard">
      <div class="notyfyHeader">
        <i class="el-icon-alarm-clock" />
        <span>待处理数量</span>
      </div>
      <div class="notifyCount">
        <el-row :gutter="10">
          <el-col :span="8">
            <div @click="handleClickBtn('/AppSporadic')">
              <div class="countText">{{ petty_qty }}</div>
              <div class="titleText">零星</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div @click="handleClickBtn('/AppEvection')">
              <div class="countText">{{ travel_qty }}</div>
              <div class="titleText">差旅费</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div @click="handleClickBtn('/AppRemittance')">
              <div class="countText">{{ funds_qty }}</div>
              <div class="titleText">汇款单</div>
            </div>
          </el-col>
          <el-col
            :span="
              String($store.state.userInfo.authority).includes('领导审核') ||
              String($store.state.userInfo.authority).includes('总经理审核')
                ? 6
                : 8
            "
          >
            <div @click="handleClickBtn('/AppWorkReport')">
              <div class="countText">{{ work_qty }}</div>
              <div class="titleText">其他</div>
            </div>
          </el-col>
          <el-col
            :span="
              String($store.state.userInfo.authority).includes('领导审核') ||
              String($store.state.userInfo.authority).includes('总经理审核')
                ? 6
                : 8
            "
          >
            <div @click="handleClickBtn('/AppReportApprove')">
              <div class="countText">{{ report_qty }}</div>
              <div class="titleText">报告</div>
            </div>
          </el-col>
          <el-col
            :span="
              String($store.state.userInfo.authority).includes('领导审核') ||
              String($store.state.userInfo.authority).includes('总经理审核')
                ? 6
                : 8
            "
          >
            <div @click="handleClickBtn('/AppMailRecords')">
              <div class="countText">{{ mail_qty }}</div>
              <div class="titleText">邮寄</div>
            </div>
          </el-col>
          <el-col
            :span="6"
            v-if="
              String($store.state.userInfo.authority).includes('领导审核') ||
                String($store.state.userInfo.authority).includes('总经理审核')
            "
          >
            <div @click="handleClickBtn('/AppQuotationApply')">
              <div class="countText">{{ quotation_qty }}</div>
              <div class="titleText">报价</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      travel_qty: 0,
      funds_qty: 0,
      petty_qty: 0,
      report_qty: 0,
      work_qty: 0,
      mail_qty: 0,
      quotation_qty: 0
    }
  },
  methods: {
    handleClickBtn(item) {
      // 路由跳转
      this.$router.push({
        path: item,
        query: {
          type: 'todo'
        }
      })
    },
    // 获取数量
    async getCount() {
      const { data: res } = await this.$http.get('/todo-qty')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.travel_qty = res.data.travel_qty
      this.funds_qty = res.data.funds_qty
      this.petty_qty = res.data.petty_qty
      this.report_qty = res.data.report_qty ? res.data.report_qty : 0
      this.work_qty = res.data.work_qty ? res.data.work_qty : 0
      this.mail_qty = res.data.mail_qty ? res.data.mail_qty : 0
      this.quotation_qty = res.data.quotation_qty ? res.data.quotation_qty : 0
    }
  },
  mounted() {
    this.getCount()
  }
}
</script>
<style lang="less" scoped>
.notifyContainer {
  margin-top: 10px;

  // box-sizing: border-box;
  padding: 20px 0;
  .notifyCard {
    height: 285px;
    width: 100%;
    border-radius: 10px;
    box-shadow: 0 0 10px #b5b4b4;
    .notyfyHeader {
      box-sizing: border-box;
      width: 100%;
      padding: 5px 15px;
      height: 35px;

      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        font-weight: bold;
      }
      i {
        font-size: 20px;
        margin-right: 5px;
      }
    }
    .notifyCount {
      height: calc(100% - 35px);
      box-sizing: border-box;
      padding-bottom: 10px;
      .el-row {
        height: 100%;
        .el-col {
          height: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          div {
            width: 100%;
            .countText {
              font-size: 30px;
              font-weight: bold;
              text-align: center;
            }
            .titleText {
              font-size: 14px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
